import React from 'react';
import { Box, BoxProps } from 'pounceV2';
import { useTheme } from '@mui/material';

const BulletedLoadingV3: React.FC<BoxProps<'svg'>> = props => {
  const theme = useTheme();

  return (
    <Box
      as="svg"
      width={75}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 20"
      preserveAspectRatio="xMidYMid"
      aria-label="Loading Animation"
      {...props}
    >
      <g transform="translate(25 10)">
        <circle
          cx="0"
          cy="0"
          r="8"
          fill={theme?.palette.tokens?.background.neutral.raised[2]}
          opacity="0.1"
        >
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="-0.3333333333333333s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
      <g transform="translate(50 10)">
        <circle
          cx="0"
          cy="0"
          r="8"
          fill={theme?.palette.tokens?.background.neutral.raised[2]}
          opacity="0.3"
        >
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="-0.16666666666666666s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
      <g transform="translate(75 10)">
        <circle cx="0" cy="0" r="8" fill={theme?.palette.tokens?.background.neutral.raised[2]}>
          <animateTransform
            attributeName="transform"
            type="scale"
            begin="0s"
            calcMode="spline"
            keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
            values="0;1;0"
            keyTimes="0;0.5;1"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </Box>
  );
};

export default BulletedLoadingV3;
